import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { GoodsPhoto } from "../../../js/ComponentManager";
/* 개발담당: 양유빈
 * 화면기능: 주문, 포장완료, 거래완료, 미송, 주문취소 리스트
 * 세부설명:
*/

export class OrderComplete extends Component {
    static displayName = OrderComplete.name;

    constructor(props) {
        super(props);
        this.state = {
            OrderHeader: [],
            OrderDtl: [],
            BuMaster: []
        };
        this.CsName = Big3Common.ContentState;
        this.Uid = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Uid, "");
        this.Qstgrp_No = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.QstgrpNo, "");
        this.Qst_Status = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.QstStatus, "");
        this.OrdgrpNo = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Ordgrp_No, 0);      
    }
    //초기화
    async componentDidMount() {
        await this.CallQstMgtGoodsListData();
    }
    //데이터 조회
    async CallQstMgtGoodsListData() {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Chat/Answer/GetQstMgtlOrderList',
                {
                    Uid: this.Uid,
                    Qstgrp_No: this.Qstgrp_No,
                    Qst_Status: this.Qst_Status,
                    Ordgrp_No: this.OrdgrpNo
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const OrderHeader = DataList.OrderHeader;
                const OrderDtl = DataList.OrderDtl;
                const BuMaster = DataList.BuMaster;
                this.setState({ OrderHeader: OrderHeader, OrderDtl: OrderDtl, BuMaster: BuMaster });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstMgtGoodsListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    Headerrender() {
        if (this.state.OrderHeader.length === 0) {
            return false;
        }
        const OrderHeader = this.state.OrderHeader[0];
        const BumasterName = this.state.BuMaster.length === 0 ? "" : this.state.BuMaster[0].bumastername || "";
        return (
            <div className="order_shop_info_box order_shop_info_box_v2">
                <div className="shop_info">
                    <div className="shop_name">{OrderHeader.whole_name}</div>
                    <div className="shop_info_icon1" onClick={(e) => { this.props.RenderComponent('WhQuestList', this.props.ContentState); e.preventDefault(); }}></div>
                    <div className="shop_info_icon2" onClick={() => { window.location.href = `tel:${OrderHeader.whole_phone}` }}></div>
                </div>
                <div className="order_number">문의번호: {this.Qstgrp_No}(주문번호: {this.OrdgrpNo})   </div>
                <div className="shop_address">상가주소 ({OrderHeader.bld_name} {OrderHeader.flr_name}층 {OrderHeader.whole_no_name}호)</div>
                <div className="shop_info_second_line">
                    <div className="shop_info_1">{OrderHeader.pay_idx_nm}</div>
                    {OrderHeader.ord_use === "SS" ? <div className="shop_info_2">사입자 : {BumasterName}</div> : <div className="shop_info_2">{OrderHeader.ord_use_nm}</div>}
                </div>
            </div>
        )
    }
    Goodssubrender(OrderList) {
        return (
            <div className="table_box">
                <React.Fragment>
                    <table className="table">
                        <colgroup>
                            <col width="40%" />
                            <col width="12%" />
                            <col width="44%" />
                        </colgroup>
                        <tbody>
                            {OrderList.map((list, idx) =>
                                <tr key={idx}>
                                    <td>{list.crd_cd_nm}  / {list.size_nm}  ({Big3Common.Util.Money(list.goods_price)})</td>
                                    <td>{list.quan}</td>
                                    <td>{Big3Common.Util.Money(list.goods_price_sum)}원</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>합계</td>
                                <td>{OrderList.reduce((acc, item) => acc + item.quan, 0)}</td>
                                <td>{Big3Common.Util.Money(OrderList.reduce((acc, item) => acc + item.goods_price_sum, 0))}원</td>
                            </tr>
                        </tfoot>
                    </table>
                </React.Fragment>
            </div>
        )
    }
    Goodsrender() {
        const OrderDtl = this.state.OrderDtl;
        const GoodsList = Big3Common.Util.groupBy(OrderDtl, list => list.goods_no);
        const OrdDtListJson = [];
        for (const item of GoodsList.entries()) {
            OrdDtListJson.push({
                "GoodsNo": item[0],
                "OrderList": item[1],
            });
        }
        return (
            <>
                {
                    OrdDtListJson.map(list =>
                        <div className="order_dtl_box" key={list.GoodsNo}>
                            <div className="order_goods_info">
                                <div className="order_goods_img">
                                    <GoodsPhoto
                                        className="order_goods_img_in"
                                        ImageSrc={list.OrderList[0].img_220}
                                        SoldoutYn={list.OrderList[0].soldout_yn}
                                    />
                                </div>
                                <div className="order_txt">
                                    <div className="goods_title">{list.OrderList[0].goods_nm}</div>
                                    <div className="goods_price">{list.OrderList[0].strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.OrderList[0].goods_price)}원`}</div>
                                </div>
                            </div>
                            {this.Goodssubrender(list.OrderList)}
                        </div>
                    )
                }
                <div className="table_box sum_table">
                    <React.Fragment>
                        <table className="table">
                            <colgroup>
                                <col width="40%" />
                                <col width="12%" />
                                <col width="44%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td>총 합계</td>
                                    <td>{OrderDtl.reduce((acc, item) => acc + item.quan, 0)}</td>
                                    <td>{Big3Common.Util.Money(OrderDtl.reduce((acc, item) => acc + item.goods_price_sum, 0))}원</td>
                                </tr>
                            </tbody>
                        </table>
                    </React.Fragment>
                </div>
            </>
        )
    }
    render() {
        const Headerrender = this.Headerrender();
        const Goodsrender = this.Goodsrender();
        return (
            <div>
                <div className="container_box   d_padding  p_b_margin">
                    {Headerrender}
                    {Goodsrender }
                </div>
            </div>
        );
    }
}
